import {
  Box,
  Button,
  Radio,
  Group,
  Drawer,
  Select,
  TextInput,
  Textarea,
  createStyles,
  rem,
  Tooltip,
  Text,
  Flex,
  Loader,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import React, { useEffect, useRef, useCallback } from "react";

import swal from "sweetalert";

import { DateInput, DatePickerInput } from "@mantine/dates";

import moment from "moment";
import { useState } from "react";
import { IoIosCloseCircle } from "react-icons/io";
import { IconChevronDown, IconFile, IconEye } from "@tabler/icons-react";
import { useSelector } from "react-redux";
import { AddMedication, EditMedication } from "../../services/patient";
import { decrypt, defaultImage, showError } from "../../utils";
import useStyles from "./style";
import CloseCircle from "../CloseCircle";
import NarcoticBox from "../NarcoticBox";
import { Dropzone } from "@mantine/dropzone";
import ScheduleMenu from "./ScheduleMenu";
import { useDisclosure, useMediaQuery } from "@mantine/hooks";
import ConfirmationModal from "../ConfirmationModal";
import { uploadFileToS3Api } from "../../utils/PresignedUrlFunction";
import { updateDiscontinue } from "../../services";
import VersionUpdateModal from "../ConfirmationModal/VersionUpdateModal";
import EmptyUploadFile from "../Svgs/EmptyUploadFile";
import EyeIconSvg from "../Svgs/EyeIconSvg";
import { FiCalendar } from "react-icons/fi";

const bgColor = "#fff";

const AddNewMedicationModal = ({
  opened,
  onclose,
  userId,
  selectedClient,
  data,
  isPreview,
  currentPage,
  getAllPatients,
  setShowClientForm,
  getClientData,
  closeAskMedicalModal,
}) => {
  const { classes, cx } = useStyles();
  const isMobile = useMediaQuery("(max-width: 768px)");
  const client = useSelector((state) => state.mar.selectedClient);
  const [loading, setLoading] = useState(false);
  const [type, setType] = useState("scheduled");
  const [files, setFiles] = useState([]);
  const { profile } = useSelector((state) => state.profile);
  const businessTimezone = profile?.business?.timezone || "UTC";
  const [frequencyData, setFrequencyData] = useState([
    "QAM",
    "QPM",
    "Q4HR",
    "Q2HR",
    "Q6HR",
    "Q8HR",
    "Q12HR",
    "AC",
    "PC",
    "BID",
    "TID",
    "QID",
    "STAT",
    "QOD",
    "Noon",
    "QD",
    "5x/day",
    "6x/day",
    "AC",
    "AC HS",
    "AC breakfast",
    "AC breakfast/dinner",
    "AC breakfast/lunch",
    "AC dinner",
    "AC lunch",
    "AC lunch/dinner",
    "BID",
    "BID AC",
    "BID HS",
    "BID PC",
    "BID w/meals",
    "Daily",
    "Daily AC",
    "Every other day",
    "Every other evening",
    "On call",
    "Once",
    "PC",
    "PC HS",
    "q2h",
    "q2min",
    "q30min",
    "q36hr",
    "q3day",
    "q3h",
    "q3min",
    "q48h",
    "q4h",
    "q5min",
    "q6h",
    "q6min",
    "q72h",
    "q4day",
    "q5day",
    "q7day",
    "q10day",
    "q14day",
    "q21day",
    "q28day",
    "q7min",
    "q8h",
    "q8min",
    "q96hrs",
    "q2week",
    "PC breakfast",
    "PC breakfast/dinner",
    "PC breakfast/lunch",
    "PC dinner",
    "PC lunch",
    "PC lunch/dinner",
    "QID",
    "TID",
    "TID AC",
    "TID HS",
    "TID PC",
    "TID w/meals",
    "Today",
    "UD",
    "Before discharge",
    "p each loose BM",
    "q10min",
    "q12h",
    "q15min",
    "q1h",
    "q1min",
    "q20min",
    "q24h",
    "q3week",
    "q4week",
    "q6week",
    "q2month",
    "q3month",
    "q4month",
    "q6month",
    "qAM",
    "qPM",
    "qAM HS",
    "qAM PM",
    "qHS",
    "qmonth",
    "qweek",
    "qyear",
    "qShift",
    "w/breakfast",
    "w/breakfast/dinner",
    "w/breakfast/lunch",
    "w/dinner",
    "w/lunch",
    "w/lunch/dinner",
    "w/meals",
    "w/meals HS",
    "x1",
    "Daily",
    "Once Weekly",
    "Once Monthly",
  ]);
  const [selectedDays, setSelectedDays] = useState(
    data?.repeatOn || [moment().format("dddd")],
  );
  const [isMedicationCountEnabled, setIsMedicationCountEnabled] =
    useState("yes");

  // RxTerms API state
  const [rxSuggestions, setRxSuggestions] = useState([]);
  const [rxLoading, setRxLoading] = useState(false);
  const [rxShowDropdown, setRxShowDropdown] = useState(false);
  const [rxStrengthOptions, setRxStrengthOptions] = useState([]);
  const rxDebounceRef = useRef(null);
  const rxDropdownRef = useRef(null);

  const parseRouteFromDisplayName = (displayName) => {
    const match = displayName.match(/\(([^)]+)\)/);
    if (!match) return null;
    const inside = match[1].toLowerCase();
    if (inside.includes("oral")) return "Orally";
    if (inside.includes("inject") || inside.includes("injectable")) return "Injection";
    if (inside.includes("inhalation") || inside.includes("inhalant")) return "Inhalation";
    if (inside.includes("nasal")) return "Nasal";
    if (inside.includes("sublingual")) return "Sublingual";
    if (inside.includes("topical")) return "Topical";
    if (inside.includes("buccal")) return "Buccal";
    if (inside.includes("rectal")) return "Rectal";
    if (inside.includes("vaginal")) return "Vaginal";
    if (inside.includes("subcutaneous")) return "Subcutaneous";
    if (inside.includes("intramuscular")) return "Intramuscular";
    if (inside.includes("cutaneous")) return "Cutaneous";
    if (inside.includes("parenteral")) return "Parenteral";
    return null;
  };

  const parseDoseForm = (text) => {
    const t = text.toLowerCase();
    if (t.includes("tablet") || t.includes(" tab")) return "Tablet";
    if (t.includes("capsule") || t.includes(" cap")) return "Capsule";
    if (t.includes("syrup")) return "Syrup";
    if (t.includes("pill")) return "Pill";
    if (t.includes("liquid")) return "Liquid";
    if (t.includes("solution")) return "Solution";
    if (t.includes("cream")) return "Cream";
    if (t.includes("ointment")) return "Ointment";
    if (t.includes("lotion")) return "Lotion";
    if (t.includes("gel")) return "Gel";
    if (t.includes("gas")) return "Gas";
    if (t.includes("inhalant") || t.includes("inhalation")) return "Inhalant";
    if (t.includes("inject")) return "Injection";
    if (t.includes("suppository")) return "Suppository";
    if (t.includes("lozenge")) return "Lozenge";
    if (t.includes("paste")) return "Paste";
    if (t.includes("patch")) return "Patch";
    if (t.includes("rinse")) return "Rinse";
    if (t.includes("shampoo")) return "Shampoo";
    if (t.includes("drop")) return "Drops";
    if (t.includes("spray")) return "Spray";
    if (t.includes("powder")) return "Powder";
    if (t.includes("cartridge")) return "Injection";
    return null;
  };

  const searchRxTerms = useCallback(async (term) => {
    if (!term || term.length < 2) {
      setRxSuggestions([]);
      setRxShowDropdown(false);
      return;
    }
    setRxLoading(true);
    try {
      const url = `https://clinicaltables.nlm.nih.gov/api/rxterms/v3/search?terms=${encodeURIComponent(term)}&ef=STRENGTHS_AND_FORMS,RXCUIS,SXDG_RXCUI,DISPLAY_NAME_SYNONYM&maxList=10`;
      const response = await fetch(url);
      const result = await response.json();
      const [total, codes, extraData, displayItems] = result;
      const mapped = (codes || []).map((code, i) => ({
        displayName: code,
        strengthsAndForms: extraData?.STRENGTHS_AND_FORMS?.[i] || [],
        rxcuis: extraData?.RXCUIS?.[i] || [],
        sxdgRxcui: extraData?.SXDG_RXCUI?.[i] || null,
        displayNameSynonym: extraData?.DISPLAY_NAME_SYNONYM?.[i] || [],
      }));
      console.log("RxTerms API — raw response:", result);
      console.log("RxTerms API — total results:", total);
      console.log("RxTerms API — mapped drugs:", mapped);
      setRxSuggestions(mapped);
      setRxShowDropdown(mapped.length > 0);
    } catch (err) {
      console.error("RxTerms API error:", err);
    } finally {
      setRxLoading(false);
    }
  }, []);

  const handleRxInputChange = (value) => {
    form.setFieldValue("medicationName", value);
    setRxStrengthOptions([]);
    form.setFieldValue("strengthAndForm", "");
    if (rxDebounceRef.current) clearTimeout(rxDebounceRef.current);
    rxDebounceRef.current = setTimeout(() => searchRxTerms(value), 400);
  };

  const handleRxSelect = (drug) => {
    console.log("RxTerms — selected drug full data:", drug);
    console.log("  Display Name:", drug.displayName);
    console.log("  Strengths & Forms:", drug.strengthsAndForms);
    console.log("  RxCUIs:", drug.rxcuis);
    console.log("  SXDG RxCUI:", drug.sxdgRxcui);
    console.log("  Synonyms:", drug.displayNameSynonym);
    form.setFieldValue("medicationName", drug.displayName);
    form.setFieldValue("strengthAndForm", "");
    const route = parseRouteFromDisplayName(drug.displayName);
    if (route) form.setFieldValue("ingestionMode", route);
    const doseForm = parseDoseForm(drug.displayName);
    if (doseForm) form.setFieldValue("dosageForm", doseForm);
    setRxStrengthOptions(drug.strengthsAndForms || []);
    setRxShowDropdown(false);
    setRxSuggestions([]);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (rxDropdownRef.current && !rxDropdownRef.current.contains(e.target)) {
        setRxShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const [confirmModal, { open: confirmOpen, close: confirmClose }] =
    useDisclosure(false);
  const [
    versionUpdateModal,
    { open: versionUpdateOpen, close: versionUpdateClose },
  ] = useDisclosure(false);

  const handleRadioChange = (event) => {
    const checked = event;
    setIsMedicationCountEnabled(checked);
    if (checked?.toLowerCase() === "no") {
      form.setFieldValue("totalMedicine", "unlimited");
      form.setFieldValue("medicineRemaining", "unlimited");
    } else if (checked?.toLowerCase() === "yes") {
      // Switching back to limited: restore last saved numeric values from DB.
      // If DB had numeric values use them; if DB was also unlimited (first time
      // switching to limited) clear the fields so the user can type new values.
      const lastTotal =
        data?.totalMedicine !== "unlimited" ? data?.totalMedicine : null;
      const lastRemaining =
        data?.medicineRemaining !== "unlimited"
          ? data?.medicineRemaining
          : null;
      form.setFieldValue("totalMedicine", lastTotal ?? null);
      form.setFieldValue("medicineRemaining", lastRemaining ?? null);
    }
  };

  const validation = () => {
    const _validation = {
      isPrescribed: (value) => (value ? null : "Required"),
      isNarcotic: (value) => (value ? null : "Required"),
      medicationName: (value) => (value ? null : "Required"),
      medicationType: (value) => (value ? null : "Required"),
      // dosage: (value) => (value ? null : "Required"),
      // unit: (value) => (value ? null : "Required"),
      // frequency: (value) => (value ? null : "Required"),
      ingestionMode: (value) => (value ? null : "Required"),
      totalMedicine: (value) => (value ? null : "Required"),
      medicationadministered: (value) => (value ? null : "Required"),
      medicationInstruction: (value) => (value ? null : "Required"),
      medicationDate: (value) => (value ? null : "Required"),
      medicineRemaining: (value) => (value ? null : "Required"),
      timeSlots: (value) => (value ? null : "Required"),
    };
    if (data) {
      delete _validation?.medicineRemaining;
    } else if (type === "PRN") {
      delete _validation?.timeSlots;
    }
    return _validation;
  };
  // const _initialValues = {
  //   isPrescribed: "Yes",
  //   isNarcotic: "Yes",
  //   medicationName: "Aleoya",
  //   medicationType: "scheduled",
  //   dosage: 200,
  //   unit: "mg",
  //   frequency: "Q4HR",
  //   ingestionMode: "Buccal",
  //   dosageForm: "Tablet",
  //   totalMedicine: 200,
  //   medicationUse: "qwertyu",
  //   medicationInstruction: "qwerty",
  //   responsibleParty: "Family",
  //   administering: "Family",
  //   medicationDate: new Date("2024/07/28"),
  //   expirationDate: new Date("2024/09/30"),
  //   timeSlots: ["02:00 AM", "08:00 PM"],
  //   medicineRemaining: 180,
  //   medicationadministered: 3,
  //   orderDate: null,
  //   repeatEvery: 1,
  //   repeatType: "week",
  //   repeatOn: [
  //     moment("2024/07/29").format("dddd"),
  //     moment("2024/07/30").format("dddd"),
  //     moment("2024/07/31").format("dddd"),
  //   ],
  //   scheduleType: "custom",
  // };
  const _initialValues = {
    isPrescribed: "",
    isNarcotic: "",
    medicationName: "",
    medicationType: "",
    dosage: "",
    unit: "",
    frequency: "",
    ingestionMode: "",
    dosageForm: "",
    strengthAndForm: "",
    totalMedicine: "",
    medicationUse: "",
    medicationInstruction: "",
    responsibleParty: "",
    administering: "",
    medicationDate: new Date(),
    expirationDate: null,
    timeSlots: [],
    medicineRemaining: "",
    medicationadministered: "",
    orderDate: null,
    repeatEvery: 1,
    repeatType: "day",
    repeatOn: [moment().format("dddd")],
    scheduleType: "daily",
    files: [],
    refillsLeft: "",
  };
  const form = useForm({
    initialValues: _initialValues,
    validate: validation(),
  });

  useEffect(() => {
    if (data) {
      const resolvedMedicationType = (() => {
        if (!data?.medicationType) return "";
        if (Array.isArray(data.medicationType)) {
          return data.medicationType[data.medicationType.length - 1]?.status || "";
        }
        try {
          const parsed = JSON.parse(data.medicationType);
          if (Array.isArray(parsed)) {
            return parsed[parsed.length - 1]?.status || "";
          }
        } catch {}
        return data.medicationType;
      })();
      setType(resolvedMedicationType || "scheduled");

      form.setValues({
        ...data,
        medicationType: resolvedMedicationType,
        medicineRemaining: data?.medicineRemaining,
        ingestionMode: data?.ingestionMethod || data?.ingestionMode,
        medicationDate: data?.medicationDate
          ? new Date(data?.medicationDate)
          : null,
        expirationDate:
          data &&
          isPreview &&
          (data?.hasExpiryDate == "false" || data?.hasExpiryDate == false)
            ? ""
            : data &&
                (data?.hasExpiryDate == "false" || data?.hasExpiryDate == false)
              ? ""
              : data?.medicationEndDate && data?.medicationEndDate != "null"
                ? new Date(data?.medicationEndDate)
                : null,
        medicationEndDate:
          data && isPreview && data?.hasExpiryDate == "false"
            ? ""
            : data && data.hasExpiryDate == "false"
              ? ""
              : data?.medicationEndDate && data?.medicationEndDate != "null"
                ? new Date(data?.medicationEndDate)
                : null,
        repeatEvery: Number(data?.repeatEvery || 1),
        orderDate:
          data?.orderDate &&
          data?.orderDate != "null" &&
          data?.orderDate != "undefined"
            ? new Date(data?.orderDate)
            : null,
        files: data?.file || [],
      });
      // setFiles(data?.file || []);

      // FIX 1: Handle file initialization properly from doctorNote URL
      if (data?.doctorNote) {
        // Create a file object from the existing doctor note URL
        const fileName =
          data.doctorNote
            .split("/")
            .pop()
            ?.replace(/%20/g, " ")
            .replace(/%252520/g, " ") || "uploaded-file.pdf";
        const existingFile = {
          path: decodeURIComponent(fileName),
          uploadURL: data.doctorNote,
        };
        setFiles([existingFile]);
      } else {
        setFiles([]);
      }
      if (data?.strengthAndForm) {
        setRxStrengthOptions([data.strengthAndForm]);
      }
      if (
        data?.medicineRemaining == "unlimited" &&
        data?.totalMedicine == "unlimited"
      ) {
        setIsMedicationCountEnabled("no");
      } else {
        setIsMedicationCountEnabled("yes");
      }
    } else {
      // No medication data — opening in create mode. Reset the form so stale
      // values from a previous edit (e.g. expirationDate from Med1) don't carry
      // over and get submitted as Med2's medicationEndDate.
      form.reset();
      setFiles([]);
      setRxStrengthOptions([]);
      setIsMedicationCountEnabled("yes");
    }
  }, [data]);

  const reset = () => {
    getClientData?.();
    setLoading(false);
    form.reset();
    setFiles([]);
    setRxStrengthOptions([]);
    setIsMedicationCountEnabled("yes");
    onclose();
  };

  const handleDateConverter = (date, timeslot = null) => {
    const currentDate = new Date(date);
    const timeString = timeslot;

    if (timeslot) {
      const [time, modifier] = timeString.split(" ");
      let [hours, minutes] = time.split(":").map(Number);

      if (modifier === "PM" && hours !== 12) {
        hours += 12;
      }
      if (modifier === "AM" && hours === 12) {
        hours = 0;
      }

      let newdate = currentDate.setHours(hours, minutes, 0, 0);
      return moment(newdate);
    } else {
      return moment(date);
    }
  };

  const setScheduleDates = (values) => {
    const _format = "YYYY-MM-DD";
    // let _startDate = moment.tz(moment(values?.medicationDate), moment.tz.guess()).tz("UTC");
    let _startDate = moment(values?.medicationDate).startOf("day");

    let _endDate = values?.expirationDate
      ? moment(values?.expirationDate)
      : // : moment(values?.medicationDate).startOf("day");
        moment().endOf("year");
    let _dateRange = [];
    let _currentDate = _startDate.clone();
    let _finalDateWithTimeSlots = [];

    if (values?.scheduleType === "custom") {
      if (values?.repeatType === "day") {
        // For Day
        while (_currentDate.isSameOrBefore(_endDate, "day")) {
          _dateRange.push(_currentDate.format(_format));
          _currentDate.add(values?.repeatEvery, "day");
        }

        _dateRange?.forEach((date) => {
          values?.timeSlots.forEach((time) => {
            _finalDateWithTimeSlots.push({
              date: moment(date).toISOString(),
              timeslot: time,
            });
            // _finalDateWithTimeSlots.push(
            //     moment.tz(moment(date + " " + time), user?.timeZone)?.toISOString()
            //     // moment(date + " " + time, "YYYY-MM-DD hh:mm A")?.toISOString()
            // );
          });
        });
      } else if (values?.repeatType === "week") {
        // For Week
        while (_currentDate.isSameOrBefore(_endDate, "day")) {
          let days = [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
          ];
          let days_dates = Array.from({ length: 7 }, (_, i) =>
            _currentDate
              .clone()
              .startOf("week")
              .add(i, "days")
              .format("MM-DD-YYYY"),
          );

          values?.repeatOn?.map((day) => {
            let index = days?.indexOf(day);
            if (
              index !== -1 &&
              moment(days_dates[index]).isSameOrAfter(_startDate) &&
              moment(days_dates[index]).isSameOrBefore(_endDate)
            ) {
              // _currentDate.format(_format)
              // _dateRange.push(moment(days_dates[index]).toISOString());
              _dateRange.push(moment(days_dates[index]).format(_format));
              // _dateRange.push(moment(days_dates[index]).tz(user?.timeZone).format(_format));
            }
          });
          _currentDate.add(values?.repeatEvery, "week");
        }

        _dateRange?.forEach((date) => {
          values?.timeSlots?.forEach((time) => {
            // _finalDateWithTimeSlots.push(
            //     moment(date + " " + time, "YYYY-MM-DD hh:mm A")?.toISOString()
            // );
            // if (serverFeTimeDiff > 20000) {
            //     console.log("🚀 ~ values?.timeSlots?.split ~ diff if:", diff)
            // } else {
            //     console.log("🚀 ~ values?.timeSlots?.split ~ diff else:", diff)

            // _finalDateWithTimeSlots.push(
            //     moment(date + " " + "00:00 AM" , "YYYY-MM-DD hh:mm A").tz("UTC").subtract(Math.abs(diff) , "hours").add(2 , "hours")?.toISOString()
            //   );

            // theory how it will work
            //  we need to cater three timeZones
            //  BE = KHI, FE = Brazil, UTC TimeZone
            //  first of all calculate the difference between BE and FE timezone here = 8 hours
            //  after
            //

            // let currentDate = moment(date, "YYYY-MM-DD").tz(user?.timeZone) // first convert this value to FE Timezone then you have to add/subtract 8 hours BE FE Timezone difference
            // let timeslot;

            // if (serverFeTimeDiff >= 0) {
            //     timeslot = currentDate.add(serverFeTimeDiff , 'hours').format("hh:mm A")
            //     currentDate = currentDate.add(serverFeTimeDiff , 'hours').tz("UTC")
            // } else {
            //     timeslot = currentDate.subtract(Math.abs(serverFeTimeDiff) , 'hours').format("hh:mm A")
            //     currentDate = currentDate.subtract(Math.abs(serverFeTimeDiff) , 'hours').tz("UTC")
            // }
            // then get start of day
            // then add the fixed hours like 02:00 AM == 2 hours
            // then convert it to UTC and save in server

            // currentDate = currentDate.startOf('day')

            // console.log('frontend time start day', currentDate)
            // currentDate = currentDate.add(2, "hours")
            // console.log(' added', currentDate)
            // console.log(' added', moment(currentDate).tz(user.timeZone))

            // currentDate = currentDate.tz("UTC")
            // console.log('timeslot ',timeslot)

            // let final = moment
            //   .tz(handleDateConverter(date, time), moment.tz.guess())
            //   .tz("UTC")
            //   .toISOString();
            let final = moment(date).toISOString();

            _finalDateWithTimeSlots.push({
              // date :  handleDateConverter(date,time)?.toISOString(),
              date: final,
              timeslot: time,
            });

            // }
          });
        });
      } else {
        // For Month
        while (_currentDate.isSameOrBefore(_endDate, "day")) {
          _dateRange.push(_currentDate.format(_format));
          _currentDate.add(values?.repeatEvery, "month");
        }

        _dateRange?.forEach((date) => {
          // values?.timeSlots?.split(",").forEach((time) => {
          values?.timeSlots?.forEach((time) => {
            _finalDateWithTimeSlots.push({
              date: moment(date).toISOString(),
              timeslot: time,
            });
            // _finalDateWithTimeSlots.push(
            //     moment.tz(moment(date + " " + time), user?.timeZone)?.toISOString()
            //     // moment(date + " " + time, "YYYY-MM-DD hh:mm A")?.toISOString()
            // );
          });
        });
      }
    } else if (values?.scheduleType === "daily") {
      while (_currentDate.isSameOrBefore(_endDate, "day")) {
        _dateRange.push(_currentDate.format(_format));
        _currentDate.add(values?.repeatEvery, "day");
      }

      _dateRange?.forEach((date) => {
        values?.timeSlots.forEach((time) => {
          _finalDateWithTimeSlots.push({
            date: moment(date).toISOString(),
            timeslot: time,
          });
        });
      });
    }
    return {
      scheduleDates: _finalDateWithTimeSlots,
      startDate: _startDate,
      endDate: _endDate,
    };
  };

  const onSave = async (values) => {
    if (
      (Number(values?.medicineRemaining) || 0) > Number(values?.totalMedicine)
    ) {
      return swal(
        "Error",
        "Current Medication Count cannot exceed Medication Total Quantity.",
        "error",
      );
    }

    if (
      Number(values?.medicationadministered) >
        Number(values?.medicineRemaining) &&
      !data
    ) {
      return swal(
        "Error",
        "Dosage Administered count cannot exceed Current Medication Count.",
        "error",
      );
    }

    let clientId = selectedClient ? selectedClient?.id : client?.id;

    if (data) {
      // Open version update modal for editing
      versionUpdateOpen(true);
      // const checkArrays = (arr1, arr2) => {
      //   if (
      //     !Array.isArray(arr1) ||
      //     !Array.isArray(arr2) ||
      //     arr1.length !== arr2.length
      //   ) {
      //     return true;
      //   }

      //   for (let i = 0; i < arr1.length; i++) {
      //     if (arr2.indexOf(arr1[i]) == -1) {
      //       return true;
      //     }
      //     // if (arr1[i] !== arr2[i]) {
      //     //   return true;
      //     // }
      //   }

      //   return false;
      // };
      // const _format = "YYYY-MM-DD";
      // const _medicationType = data?.medicationType !== values?.medicationType;
      // const _startDate =
      //   moment(data?.medicationDate).format(_format) !==
      //   moment(values?.medicationDate).format(_format);
      // const _endDate =
      //   data?.expirationDate &&
      //   data?.expirationDate != "null" &&
      //   moment(data?.expirationDate).format(_format) !==
      //     moment(values?.expirationDate).format(_format);
      // const _timeSlots = checkArrays(data?.timeSlots, values?.timeSlots);
      // const _repeatOn =
      //   data?.scheduleType === "custom"
      //     ? checkArrays(data?.repeatOn, values?.repeatOn)
      //     : false;

      // const _scheduleType =
      //   data?.scheduleType && values?.scheduleType
      //     ? data?.scheduleType !== values?.scheduleType
      //     : false;
      // const _repeatEvery =
      //   data?.scheduleType === "custom"
      //     ? Number(data?.repeatEvery) &&
      //       Number(data?.repeatEvery) != Number(values?.repeatEvery)
      //     : false;
      // const _repeatType =
      //   data?.scheduleType === "custom"
      //     ? data?.repeatType && data?.repeatType !== values?.repeatType
      //     : false;

      //     if (
      //       _medicationType ||
      //       _startDate ||
      //       _endDate ||
      //       _timeSlots ||
      //       _scheduleType ||
      //       _repeatEvery ||
      //       _repeatType ||
      //       _repeatOn
      //     ) {
      //   confirmOpen();
      // } else {
      //   handleEdit(false);
      // }
    } else {
      if (!values?.timeSlots?.length && values?.medicationType != "PRN")
        return showError("Select time slots for medicine.");

      const { scheduleDates } = setScheduleDates(values);

      const _formData = new FormData();
      files?.length > 0 && _formData.append("file", files[0]?.uploadURL);
      _formData.append("administering", values?.administering);
      _formData.append("dosage", values?.dosage);
      _formData.append("dosageForm", values?.dosageForm);
      _formData.append(
        "expirationDate",
        // values?.expirationDate ? values?.expirationDate?.toISOString() : null
        values?.expirationDate
          ? moment(values?.expirationDate)?.endOf("D")?.toISOString()
          : null,
        // values?.expirationDate ? moment(values?.expirationDate)?.endOf("D") : null
      );
      _formData.append("frequency", values?.frequency);
      _formData.append("ingestionMode", values?.ingestionMode);
      _formData.append("isNarcotic", values?.isNarcotic);
      _formData.append("isPrescribed", values?.isPrescribed);
      _formData.append(
        "medicationDate",
        values?.medicationDate ? values?.medicationDate?.toISOString() : null,
        // values?.medicationDate ? moment(values?.medicationDate)?.startOf("D")?.toISOString() : null
        // values?.medicationDate ? moment(values?.medicationDate)?.startOf("D") : null
      );

      // Start of Day on Frontend Date with 00:00:00 1 Aug 2024 Karachi Time.

      _formData.append("medicationInstruction", values?.medicationInstruction);
      _formData.append("medicationName", values?.medicationName);
      _formData.append(
        "medicationType",
        JSON.stringify([
          { status: values?.medicationType, date: moment().toISOString() },
        ]),
      );
      _formData.append("medicationUse", values?.medicationUse);
      _formData.append(
        "medicationadministered",
        values?.medicationadministered,
      );
      _formData.append(
        "medicineRemaining",
        // Number(values?.medicineRemaining) || 0
        values?.medicineRemaining,
      );
      _formData.append("orderDate", values?.orderDate?.toISOString());
      _formData.append("responsibleParty", values?.responsibleParty);
      _formData.append("timeSlots", values?.timeSlots);
      _formData.append("totalMedicine", values?.totalMedicine);
      _formData.append("unit", values?.unit);
      _formData.append("strengthAndForm", values?.strengthAndForm || "");
      if (values?.refillsLeft !== "" && values?.refillsLeft != null) {
        _formData.append("refillsLeft", Number(values.refillsLeft));
      }
      _formData.append(
        "medicineProvided",
        Number(values?.medicineRemaining) || 0,
      );
      _formData.append("id", Date.now());
      // Always send all schedule fields so backend stores correct metadata in MAR doc
      _formData.append("scheduleType", values?.scheduleType || "daily");
      _formData.append(
        "repeatEvery",
        values?.scheduleType === "custom" ? values?.repeatEvery || 1 : 1,
      );
      _formData.append(
        "repeatType",
        values?.scheduleType === "custom" ? values?.repeatType || "day" : "",
      );
      _formData.append(
        "repeatOn",
        values?.scheduleType === "custom"
          ? (values?.repeatOn || []).join(",")
          : "",
      );
      _formData.append(
        "medicationEndDate",
        values?.expirationDate
          ? // ? moment(values?.expirationDate)?.toISOString()
            moment(values?.expirationDate)?.endOf("D")?.toISOString()
          : // ? moment(values?.expirationDate)?.endOf("D")
            moment().endOf("year").toISOString(),
      );
      // _formData.append(
      //   "medicationEndDate",
      //   values?.expirationDate
      //     ? moment(values?.expirationDate)?.endOf("D")?.toISOString()
      //     : moment(values?.medicationDate)?.endOf("D")?.toISOString()
      // );

      _formData.append("scheduleDates", JSON.stringify(scheduleDates));

      _formData.append("hasExpiryDate", values?.expirationDate ? true : false);
      // _formData.append("timezone", businessTimezone ? businessTimezone : moment.tz.guess());

      setLoading(true);
      await AddMedication(_formData, clientId, false, null, reset);
      if (selectedClient) {
        closeAskMedicalModal();
        setShowClientForm(false);
      }
      setLoading(false);
    }
  };

  const handleUpdateThisMedication = () => {
    // Close version update modal
    versionUpdateClose();
    const checkArrays = (arr1, arr2) => {
      if (
        !Array.isArray(arr1) ||
        !Array.isArray(arr2) ||
        arr1.length !== arr2.length
      ) {
        return true;
      }

      for (let i = 0; i < arr1.length; i++) {
        if (arr2.indexOf(arr1[i]) == -1) {
          return true;
        }
        // if (arr1[i] !== arr2[i]) {
        //   return true;
        // }
      }

      return false;
    };
    const values = form.values;
    const _format = "YYYY-MM-DD";
    const _medicationType = data?.medicationType !== values?.medicationType;
    const _startDate =
      moment(data?.medicationDate).format(_format) !==
      moment(values?.medicationDate).format(_format);
    const _endDate =
      data?.expirationDate &&
      data?.expirationDate != "null" &&
      moment(data?.expirationDate).format(_format) !==
        moment(values?.expirationDate).format(_format);
    const _timeSlots = checkArrays(data?.timeSlots, values?.timeSlots);
    const _repeatOn =
      data?.scheduleType === "custom"
        ? checkArrays(data?.repeatOn, values?.repeatOn)
        : false;

    const _scheduleType =
      data?.scheduleType && values?.scheduleType
        ? data?.scheduleType !== values?.scheduleType
        : false;
    const _repeatEvery =
      data?.scheduleType === "custom"
        ? Number(data?.repeatEvery) &&
          Number(data?.repeatEvery) != Number(values?.repeatEvery)
        : false;
    const _repeatType =
      data?.scheduleType === "custom"
        ? data?.repeatType && data?.repeatType !== values?.repeatType
        : false;

    if (
      _medicationType ||
      _startDate ||
      _endDate ||
      _timeSlots ||
      _scheduleType ||
      _repeatEvery ||
      _repeatType ||
      _repeatOn
    ) {
      confirmOpen();
    } else {
      handleEdit(false);
    }
  };

  const handleEdit = async (confirm) => {
    if (confirmModal) {
      confirmClose();
    }
    const values = form.values;

    let current = moment().startOf("day");
    // const { scheduleDates } = setScheduleDates({
    //   ...values,
    //   medicationDate: current,
    // });

    // const { scheduleDates } = setScheduleDates(values)

    const _formData = new FormData();
    // files?.length > 0 && _formData.append("file", files[0]?.uploadURL);
    if (files?.length > 0) {
      _formData.append("file", files[0]?.uploadURL);
    } else if (data?.doctorNote) {
      // If files array is empty but data has a doctor note, preserve it
      _formData.append("file", data.doctorNote);
    }
    _formData.append("administering", values?.administering);
    _formData.append("dosage", values?.dosage);
    _formData.append("dosageForm", values?.dosageForm);
    _formData.append(
      "expirationDate",
      values?.expirationDate ? values?.expirationDate?.toISOString() : null,
    );
    _formData.append("hasExpiryDate", values?.expirationDate ? true : false);
    _formData.append("frequency", values?.frequency);
    _formData.append("ingestionMode", values?.ingestionMode);
    _formData.append("isNarcotic", values?.isNarcotic);
    _formData.append("isPrescribed", values?.isPrescribed);
    _formData.append(
      "medicationDate",
      values?.medicationDate ? values?.medicationDate?.toISOString() : null,
    );
    _formData.append("medicationInstruction", values?.medicationInstruction);
    _formData.append("medicationName", values?.medicationName);
    _formData.append(
      "medicationType",
      JSON.stringify(
        Array.isArray(data?.medicationType)
          ? [
              ...data.medicationType,
              { status: values?.medicationType, date: moment().toISOString() },
            ]
          : [{ status: values?.medicationType, date: moment().toISOString() }],
      ),
    );
    _formData.append("medicationUse", values?.medicationUse);
    _formData.append("medicationadministered", values?.medicationadministered);
    // _formData.append("medicineRemaining", Number(data?.medicineRemaining) || 0);
    // _formData.append("medicineRemaining", data?.medicineRemaining);
    _formData.append("orderDate", values?.orderDate?.toISOString());
    _formData.append("responsibleParty", values?.responsibleParty);
    _formData.append("timeSlots", values?.timeSlots);
    // Use isMedicationCountEnabled as source of truth for totalMedicine
    _formData.append(
      "totalMedicine",
      isMedicationCountEnabled?.toLowerCase() === "no"
        ? "unlimited"
        : values?.totalMedicine,
    );
    _formData.append("unit", values?.unit);
    if (values?.refillsLeft !== "" && values?.refillsLeft != null) {
      _formData.append("refillsLeft", Number(values.refillsLeft));
    }
    _formData.append("strengthAndForm", values?.strengthAndForm || "");
    _formData.append("medicineProvided", Number(data?.medicineRemaining) || 0);
    _formData.append("id", data?.id);
    // Always send all schedule fields so backend can clear stale custom values when switching to daily
    _formData.append("scheduleType", values?.scheduleType || "daily");
    _formData.append(
      "repeatEvery",
      values?.scheduleType === "custom" ? values?.repeatEvery || 1 : 1,
    );
    _formData.append(
      "repeatType",
      values?.scheduleType === "custom" ? values?.repeatType || "day" : "",
    );
    _formData.append(
      "repeatOn",
      values?.scheduleType === "custom"
        ? (values?.repeatOn || []).join(",")
        : "",
    );
    _formData.append("confirm", confirm);
    _formData.append(
      "medicationEndDate",
      values?.expirationDate
        ? moment(values?.expirationDate)?.toISOString()
        : moment().endOf("year").toISOString(),
      // : moment(values?.medicationDate)?.toISOString()
    );
    // _formData.append("hasExpiryDate", values?.expirationDate ? true : false);
    // _formData.append("scheduleDates", JSON.stringify(scheduleDates));

    // Always derive medicineRemaining and totalMedicine from the current toggle
    // state, not from the original DB value. This fixes limited→unlimited→limited
    // toggling where the old code sent data?.medicineRemaining (stale DB value).
    if (isMedicationCountEnabled?.toLowerCase() === "no") {
      _formData.append("medicineRemaining", "unlimited");
    } else {
      // Limited: send whatever the user currently has in the form fields.
      // values?.medicineRemaining is kept in sync by handleRadioChange.
      _formData.append("medicineRemaining", values?.medicineRemaining);
    }

    let newStartDate = moment(values?.medicationDate).format("MM-DD-YYYY");
    let oldStartDate = moment(data?.medicationDate).format("MM-DD-YYYY");
    // let oldScheduleType = data?.scheduleType;
    // _formData.append("old_schedule_type", oldScheduleType);
    // _formData.append("old_timeSlots", data?.timeSlots);

    let newEndDate = values?.expirationDate
      ? moment(values?.expirationDate)?.toISOString()
      : moment(values?.medicationDate)?.toISOString();
    // let newEndDate = moment(values?.expirationDate).format("MM-DD-YYYY");
    let oldEndDate = moment(data?.medicationEndDate).format("MM-DD-YYYY");

    if (moment(newStartDate) < moment(oldStartDate)) {
      // if(values?.scheduleType === "custom" && values?.repeatType === "week"){
      //   const { scheduleDates } = setScheduleDates({
      //     medicationDate: values?.medicationDate,
      //     expirationDate: moment(data?.expirationDate),
      //     // expirationDate: moment(data?.medicationDate).subtract(1, "days"),
      //     scheduleType: values?.scheduleType,
      //     repeatType: values?.repeatType,
      //     repeatEvery: values?.repeatEvery,
      //     repeatOn: values?.repeatOn,
      //     timeSlots: values?.timeSlots,
      //   })

      //   let filteredSchedules = scheduleDates?.filter(_s => moment(_s?.date).isBefore(data?.medicationDate))

      //   _formData.append("new_start_schedules", JSON.stringify(filteredSchedules));
      //   _formData.append("old_start_date", moment(oldStartDate));
      //   _formData.append("new_start_date", moment(newStartDate));
      // } else {
      //   const { scheduleDates } = setScheduleDates({
      //     medicationDate: values?.medicationDate,
      //     expirationDate: moment(data?.medicationDate).subtract(1, "days"),
      //     scheduleType: values?.scheduleType,
      //     repeatType: values?.repeatType,
      //     repeatEvery: values?.repeatEvery,
      //     repeatOn: values?.repeatOn,
      //     timeSlots: values?.timeSlots,
      //   })

      //   _formData.append("new_start_schedules", JSON.stringify(scheduleDates));
      //   _formData.append("old_start_date", moment(oldStartDate));
      //   _formData.append("new_start_date", moment(newStartDate));
      // }

      const { scheduleDates } = setScheduleDates({
        medicationDate: values?.medicationDate,
        expirationDate: moment(data?.medicationDate).subtract(1, "days"),
        scheduleType: values?.scheduleType,
        repeatType: values?.repeatType,
        repeatEvery: values?.repeatEvery,
        repeatOn: values?.repeatOn,
        timeSlots: values?.timeSlots,
      });

      _formData.append("new_start_schedules", JSON.stringify(scheduleDates));
      _formData.append("old_start_date", moment(oldStartDate));
      _formData.append("new_start_date", moment(newStartDate));
    } else if (moment(newStartDate) > moment(oldStartDate)) {
      _formData.append("old_start_date", moment(oldStartDate));
      _formData.append("new_start_date", moment(newStartDate));
    }

    if (moment(newEndDate) < moment(oldEndDate)) {
      _formData.append("old_end_date", moment(oldEndDate));
      _formData.append("new_end_date", moment(newEndDate));
    } else if (moment(newEndDate) > moment(oldEndDate)) {
      // if(values?.scheduleType === "custom" && values?.repeatType === "day"){
      if (values?.scheduleType === "custom") {
        const { scheduleDates } = setScheduleDates({
          // medicationDate: moment(data?.expirationDate).add(1, "days"),
          medicationDate: values?.medicationDate,
          expirationDate: values?.expirationDate,
          scheduleType: values?.scheduleType,
          repeatType: values?.repeatType,
          repeatEvery: values?.repeatEvery,
          repeatOn: values?.repeatOn,
          timeSlots: values?.timeSlots,
        });
        let filteredSchedules = scheduleDates?.filter((_s) =>
          moment(_s?.date).isAfter(data?.expirationDate),
        );

        _formData.append(
          "new_end_schedules",
          JSON.stringify(filteredSchedules),
        );
      } else {
        const { scheduleDates } = setScheduleDates({
          medicationDate: moment(data?.expirationDate).add(1, "days"),
          expirationDate: values?.expirationDate,
          scheduleType: values?.scheduleType,
          repeatType: values?.repeatType,
          repeatEvery: values?.repeatEvery,
          repeatOn: values?.repeatOn,
          timeSlots: values?.timeSlots,
        });

        _formData.append("new_end_schedules", JSON.stringify(scheduleDates));
      }

      _formData.append("old_end_date", moment(oldEndDate));
      _formData.append("new_end_date", moment(newEndDate));
    }

    const scheduleChanged =
      values?.scheduleType !== data?.scheduleType ||
      JSON.stringify(values?.timeSlots) !== JSON.stringify(data?.timeSlots) ||
      JSON.stringify(values?.repeatOn) !== JSON.stringify(data?.repeatOn) ||
      values?.repeatType !== data?.repeatType ||
      Number(values?.repeatEvery) !== Number(data?.repeatEvery);

    if (scheduleChanged) {
      const { scheduleDates: newScheduleDates } = setScheduleDates({
        medicationDate: values?.medicationDate,
        expirationDate: values?.expirationDate,
        scheduleType: values?.scheduleType,
        repeatType: values?.repeatType,
        repeatEvery: values?.repeatEvery,
        repeatOn: values?.repeatOn,
        timeSlots: values?.timeSlots,
      });
      _formData.append("updateSchedule", true);
      _formData.append("scheduleDates", JSON.stringify(newScheduleDates));
    }
    setLoading(true);
    await EditMedication(_formData, client?.id, false, reset);
    if (versionUpdateModal) {
      versionUpdateClose();
    }
    setLoading(false);
  };

  const handleNewVersion = async (newStartDate, newExpirationDate) => {
    setLoading(true);
    const values = form.values;

    try {
      const obj = {
        clientId: client?.id,
        medicationId: data?.id,
        discontinuedOn: moment(newStartDate)
          .subtract(1, "days")
          .endOf("day")
          .toISOString(),
      };
      const res = await updateDiscontinue(obj, client?.id);

      if (res?.status !== 200) {
        throw new Error("Failed to discontinue medication");
      }

      const versionValues = {
        ...values,
        medicationDate: newStartDate ? new Date(newStartDate) : new Date(),
        expirationDate: newExpirationDate ? new Date(newExpirationDate) : null,
      };

      const { scheduleDates } = setScheduleDates(versionValues);

      const _formData = new FormData();
      files?.length > 0 && _formData.append("file", files[0]?.uploadURL);
      _formData.append("administering", values?.administering);
      _formData.append("dosage", values?.dosage);
      _formData.append("dosageForm", values?.dosageForm);
      _formData.append(
        "expirationDate",
        versionValues?.expirationDate
          ? moment(versionValues?.expirationDate)?.endOf("D")?.toISOString()
          : null,
      );
      _formData.append("frequency", values?.frequency);
      _formData.append("ingestionMode", values?.ingestionMode);
      _formData.append("isNarcotic", values?.isNarcotic);
      _formData.append("isPrescribed", values?.isPrescribed);
      _formData.append(
        "medicationDate",
        versionValues?.medicationDate
          ? versionValues?.medicationDate?.toISOString()
          : null,
      );

      _formData.append("medicationInstruction", values?.medicationInstruction);
      _formData.append("medicationName", values?.medicationName);
      _formData.append(
        "medicationType",
        JSON.stringify([
          { status: values?.medicationType, date: moment().toISOString() },
        ]),
      );
      _formData.append("medicationUse", values?.medicationUse);
      _formData.append(
        "medicationadministered",
        values?.medicationadministered,
      );
      _formData.append("medicineRemaining", values?.medicineRemaining);
      _formData.append("orderDate", values?.orderDate?.toISOString());
      _formData.append("responsibleParty", values?.responsibleParty);
      _formData.append("timeSlots", values?.timeSlots);
      _formData.append("totalMedicine", values?.totalMedicine);
      _formData.append("unit", values?.unit);
      if (values?.refillsLeft !== "" && values?.refillsLeft != null) {
        _formData.append("refillsLeft", Number(values.refillsLeft));
      }
      _formData.append("strengthAndForm", values?.strengthAndForm || "");
      _formData.append(
        "medicineProvided",
        Number(values?.medicineRemaining) || 0,
      );
      _formData.append("id", Date.now());
      // Always send all schedule fields so backend stores correct metadata in MAR doc
      _formData.append("scheduleType", values?.scheduleType || "daily");
      _formData.append(
        "repeatEvery",
        values?.scheduleType === "custom" ? values?.repeatEvery || 1 : 1,
      );
      _formData.append(
        "repeatType",
        values?.scheduleType === "custom" ? values?.repeatType || "day" : "",
      );
      _formData.append(
        "repeatOn",
        values?.scheduleType === "custom"
          ? (values?.repeatOn || []).join(",")
          : "",
      );
      _formData.append(
        "medicationEndDate",
        versionValues?.expirationDate
          ? moment(versionValues?.expirationDate)?.endOf("D")?.toISOString()
          : moment().endOf("year").toISOString(),
      );
      // _formData.append(
      //   "medicationEndDate",
      //   values?.expirationDate
      //     ? moment(values?.expirationDate)?.endOf("D")?.toISOString()
      //     : moment(values?.medicationDate)?.endOf("D")?.toISOString()
      // );

      _formData.append("scheduleDates", JSON.stringify(scheduleDates));

      _formData.append(
        "hasExpiryDate",
        versionValues?.expirationDate ? true : false,
      );
      _formData.append("previousMedId", data?.id);

      await AddMedication(_formData, client?.id, false, null, reset, false);

      versionUpdateClose();
      setLoading(false);
      swal(
        "Success",
        "New medication version created successfully.",
        "success",
      );
    } catch (error) {
      console.error(error);
      showError(error.message || "Operation failed");
      setLoading(false);
    }
  };

  const formatString = (str) => {
    const words = str?.split("");
    if (words?.length <= 15) {
      return str;
    }
    const startWords = words?.slice(0, 10)?.join("");
    const endWords = words?.slice(-10)?.join("");
    return `${startWords} ... ${endWords}`;
  };

  const daysOfWeek = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  const handleDownloadFile = async (url) => {
    try {
      if (url) {
        const response = await fetch(url);
        const blob = await response.blob();
        const filename = url?.split("/")?.pop();
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        link.click();
      } else {
        console.error("No url found");
      }
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  const onChangeMedStartDate = (_sDate) => {
    if (data) {
      // form.values?.repeatType === "week"
      if (form.values?.scheduleType === "custom") {
        if (form.values?.repeatType === "day") {
          const original = moment(data?.medicationDate);
          const newDate = moment(_sDate);

          let diff;

          if (newDate < original) {
            diff = original.diff(newDate, "days");
          } else if (newDate > original) {
            diff = newDate.diff(original, "days");
          }

          let repeatDays = Number(form.values?.repeatEvery);

          // Check if the difference is a multiple of repeatDays
          if (diff % repeatDays !== 0) {
            const remainder = Math.abs(diff % repeatDays);
            let validPrevious, validNext;

            if (newDate.isBefore(original)) {
              // Moving backward
              validPrevious = newDate.clone().subtract(remainder, "days");
              validNext = validPrevious.clone().subtract(repeatDays, "days");
            } else {
              // Moving forward
              validPrevious = newDate.clone().subtract(remainder, "days");
              validNext = newDate.clone().add(repeatDays - remainder, "days");
            }

            return alert("Invalid start date");
          } else {
            form.setFieldValue("medicationDate", _sDate);
          }
        } else if (form.values?.repeatType === "week") {
          const original = moment(data?.medicationDate);
          const newDate = moment(_sDate);
          const repeatEvery = Number(form.values?.repeatEvery); // e.g., 1 or 2
          const repeatOn = form.values?.repeatOn || [];

          const newDayName = newDate.format("dddd"); // Day name of new start date

          // Step 2: Ensure the new start date is also in repeatOn
          if (!repeatOn.includes(newDayName)) {
            return alert(
              `Invalid start date. Please select a date that falls on: ${repeatOn.join(
                ", ",
              )}.`,
            );
          }

          // console.log("firstValidDay and newDate", moment(firstValidDay).format("MM-DD-YYYY"), moment(newDate).format("MM-DD-YYYY"))

          // Step 3: Ensure the new date is a multiple of repeatEvery weeks from first valid occurrence
          let weekDiff;
          if (newDate < original) {
            weekDiff = original.diff(newDate.startOf("week"), "weeks");
          } else {
            weekDiff = newDate.diff(original.startOf("week"), "weeks");
          }

          if (Math.abs(weekDiff) % repeatEvery !== 0) {
            return alert(
              `Invalid start date. Please select a date that repeats every ${repeatEvery} weeks on ${repeatOn.join(
                ", ",
              )}.`,
            );
          } else {
            form.setFieldValue("medicationDate", _sDate);
          }
        } else if (form.values?.repeatType === "month") {
          const original = moment(data?.medicationDate);
          const newDate = moment(_sDate);
          const originalDay = original.date(); // e.g., 10th of the month
          const newDay = newDate.date();
          const repeatMonths = Number(form.values?.repeatEvery); // e.g., 1 or 2

          if (repeatMonths === 1) {
            // User can only select the same day of the month (e.g., 10th)
            if (newDay !== originalDay) {
              return alert(
                `Invalid start date. Please select the ${originalDay}th of the month.`,
              );
            }
          } else if (repeatMonths > 1) {
            // Ensure the new date is every `repeatMonths` interval
            const monthDiff = newDate.diff(original, "months");
            if (monthDiff % repeatMonths !== 0 || newDay !== originalDay) {
              return alert(
                `Invalid start date. Please select the ${originalDay}th every ${repeatMonths} months.`,
              );
            }
          }

          form.setFieldValue("medicationDate", _sDate);
        }
      } else {
        form.setFieldValue("medicationDate", _sDate);
      }
    } else {
      form.setFieldValue("medicationDate", _sDate);
    }
  };

  const onChangeMedEndDate = (_sDate) => {
    if (data) {
      if (form.values?.scheduleType === "custom") {
        if (form.values?.repeatType === "day") {
          const original = moment(data?.expirationDate);
          const newDate = moment(_sDate);

          let diff;

          if (newDate < original) {
            diff = original.diff(newDate, "days");
          } else if (newDate > original) {
            diff = newDate.diff(original, "days");
          }

          let repeatDays = Number(form.values?.repeatEvery);

          // Check if the difference is a multiple of repeatDays
          if (diff % repeatDays !== 0) {
            const remainder = Math.abs(diff % repeatDays);
            let validPrevious, validNext;

            if (newDate.isBefore(original)) {
              // Moving backward
              validPrevious = newDate.clone().subtract(remainder, "days");
              validNext = validPrevious.clone().subtract(repeatDays, "days");
            } else {
              // Moving forward
              validPrevious = newDate.clone().subtract(remainder, "days");
              validNext = newDate.clone().add(repeatDays - remainder, "days");
            }

            return alert("Invalid end date");
          } else {
            form.setFieldValue("expirationDate", _sDate);
          }
          // } else if(form.values?.repeatType === "month"){
        } else {
          form.setFieldValue("expirationDate", _sDate);
        }
      } else {
        form.setFieldValue("expirationDate", _sDate);
      }
    } else {
      form.setFieldValue("expirationDate", _sDate);
    }
  };

  return (
    <Drawer
      // className={classes.addMedicationModal}
      opened={opened}
      onClose={() => {
        onclose();
        form?.reset();
        setRxStrengthOptions([]);
      }}
      closeOnClickOutside={false}
      withCloseButton={false}
      offset={isMobile ? 0 : 8}
      size={isMobile ? "100%" : "55%"}
      sx={{
        ".mantine-11shxvp": {
          background: "#F5F5F5",
          borderTopLeftRadius: isMobile ? 0 : 16,
          borderBottomLeftRadius: isMobile ? 0 : 16,
        },
        ".mantine-1q36a81": {
          padding: "0",
        },
      }}
      zIndex={1000}
      position="right"
      overlayProps={{ backgroundOpacity: 2.5, blur: 4 }}
      shadow="md"
      styles={{
        root: {  touchAction: isMobile ?  "pan-x pan-y pinch-zoom" : undefined },
        overlay: { touchAction:  isMobile ? "pan-x pan-y pinch-zoom" : undefined },
        inner: { touchAction: isMobile ? "pan-x pan-y pinch-zoom" : undefined },
        body: { touchAction: isMobile ? "pan-x pan-y pinch-zoom" : undefined },
      }}
    >
      <form
        className={classes.modalBody}
        onSubmit={form?.onSubmit((values) => onSave(values))}
      >
        <div className={classes.modalTopBar}>
          <h3 className={classes.modalTitle}>
            {data
              ? isPreview
                ? "Preview Medication"
                : "Change Medication"
              : "Add new medication"}
          </h3>
          <button
            type="button"
            className={classes.modalCloseBtn}
            onClick={() => {
              onclose();
              form?.reset();
              setRxStrengthOptions([]);
            }}
          >
            ✕
          </button>
        </div>
        <div className={classes.formBox}>
          <div className={classes.wrapper}>
            <div className={classes.clientCard}>
              <img
                src={
                  selectedClient
                    ? decrypt(selectedClient?.imageurl) || defaultImage
                    : decrypt(client?.imageurl) || defaultImage
                }
                alt="client"
                className={classes.clientAvatar}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = defaultImage;
                }}
              />
              <div className={classes.clientInfo}>
                <p className={classes.clientName}>
                  {selectedClient
                    ? decrypt(selectedClient?.name)
                    : client?.name}
                </p>
                <p className={classes.clientId}>
                  {selectedClient
                    ? selectedClient?.id?.slice(0, 6)?.toUpperCase()
                    : client?.id?.slice(0, 6)?.toUpperCase()}
                </p>
              </div>
            </div>
            <Box className={classes.medContainer}>
              <div className={classes.topFieldsBox}>
                {/* Is this a prescription medication? */}
                <div className="isPrescribed">
                  <Radio.Group
                    name="isPrescribed"
                    label="Is this a prescription medication?"
                    {...form.getInputProps("isPrescribed")}
                    required
                    withAsterisk
                    className={classes.radioGroupWrapper}
                  >
                    <Group className={classes.radioGroup}>
                      <Radio disabled={isPreview} value="Yes" label="Yes" />
                      <Radio disabled={isPreview} value="No" label="No" />
                    </Group>
                  </Radio.Group>
                </div>
                <div className="isNarcotic">
                  <Radio.Group
                    name="isNarcotic"
                    label="Is this a narcotic?"
                    {...form.getInputProps("isNarcotic")}
                    required
                    withAsterisk
                    disabled={isPreview}
                    className={classes.radioGroupWrapper}
                  >
                    <Group className={classes.radioGroup}>
                      <Radio disabled={isPreview} value="Yes" label="Yes" />
                      <Radio disabled={isPreview} value="No" label="No" />
                    </Group>
                  </Radio.Group>
                  {/* <NarcoticBox /> */}
                </div>
              </div>

              <div className={classes.formRow}>
                {/* medication name — RxTerms autocomplete */}
                <div ref={rxDropdownRef} style={{ position: "relative", flex: 1 }}>
                  <CustomTextInput
                    id="medication-name"
                    label={"Medication Name"}
                    placeholder={"Enter Medication Name"}
                    value={form.values.medicationName}
                    onChange={(e) => handleRxInputChange(e.target.value)}
                    error={form.errors.medicationName}
                    withAsterisk
                    disabled={isPreview}
                    autoComplete="off"
                    rightSection={
                      rxLoading ? (
                        <Loader color="yellow" size="xs" />
                      ) : form.values.medicationName && !isPreview ? (
                        <IoIosCloseCircle
                          style={{ cursor: "pointer", color: "#aaa", fontSize: 18 }}
                          onMouseDown={(e) => {
                            e.preventDefault();
                            form.setFieldValue("medicationName", "");
                            form.setFieldValue("strengthAndForm", "");
                            setRxStrengthOptions([]);
                            setRxShowDropdown(false);
                            setRxSuggestions([]);
                          }}
                        />
                      ) : null
                    }
                  />
                  {rxShowDropdown && !isPreview && (
                    <div
                      style={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        right: 0,
                        background: "#fff",
                        border: "1px solid #dee2e6",
                        borderRadius: 8,
                        boxShadow: "0 4px 16px rgba(0,0,0,0.12)",
                        zIndex: 9999,
                        maxHeight: 260,
                        overflowY: "auto",
                      }}
                    >
                      {rxSuggestions.map((drug, idx) => (
                        <div
                          key={idx}
                          onMouseDown={() => handleRxSelect(drug)}
                          style={{
                            padding: "10px 14px",
                            cursor: "pointer",
                            borderBottom: idx < rxSuggestions.length - 1 ? "1px solid #f1f3f5" : "none",
                          }}
                          onMouseEnter={(e) => (e.currentTarget.style.background = "#f8f9fa")}
                          onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
                        >
                          <Text size="sm" weight={500}>{drug.displayName}</Text>
                          {drug.strengthsAndForms.length > 0 && (
                            <Text size="xs" color="dimmed">
                              {drug.strengthsAndForms.slice(0, 3).join(" · ")}
                              {drug.strengthsAndForms.length > 3 ? ` +${drug.strengthsAndForms.length - 3} more` : ""}
                            </Text>
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                {/* medication type */}
                <CustomSelectBox
                  id="medication-type"
                  label={"Medication Type"}
                  {...form.getInputProps("medicationType")}
                  onChange={(value) => {
                    form.setFieldValue("medicationType", value);
                    setType(value);
                  }}
                  placeholder={"Select Medication Type"}
                  withAsterisk
                  data={[
                    { value: "PRN", label: "PRN" },
                    { value: "scheduled", label: "SCHEDULED" },
                  ]}
                  disabled={isPreview}
                />
              </div>

              <div className={classes.medicationDosageBox}>
                <p className="dosageHeading">Dosage Information *</p>
                <div className={classes.medicationDosageInner}>
                  {rxStrengthOptions.length === 0 ? (
                    <>
                      {/* medication amount */}
                      <CountField
                        id="medication-amount"
                        label="Amount"
                        value={form.values.dosage}
                        error={form.errors.dosage}
                        disabled={isPreview}
                        onChange={(e) =>
                          form.setFieldValue("dosage", e.target.value)
                        }
                        onDecrement={() => {
                          const v = parseFloat(form.values.dosage) || 0;
                          form.setFieldValue("dosage", String(Math.max(0, v - 1)));
                        }}
                        onIncrement={() => {
                          const v = parseFloat(form.values.dosage) || 0;
                          form.setFieldValue("dosage", String(v + 1));
                        }}
                      />
                      {/* medication unit */}
                      <Select
                        id="medication-unit"
                        label="Unit"
                        data={[
                          { value: "mg", label: "mg" },
                          { value: "mg/ml", label: "mg/ml" },
                          { value: "cc", label: "cc" },
                          { value: "iu", label: "iu" },
                          { value: "ml", label: "ml" },
                          { value: "puffs", label: "puffs" },
                          { value: "mcg", label: "mcg" },
                          { value: "g", label: "g" },
                          { value: "oz", label: "oz" },
                          { value: "gtts", label: "gtts" },
                          { value: "spray", label: "spray" },
                          { value: "drops", label: "drops" },
                          { value: "unit", label: "unit" },
                          { value: "tablet", label: "tablet" },
                        ]}
                        className={classes.inputStyle}
                        placeholder="Select Unit"
                        {...form.getInputProps("unit")}
                        rightSection={<IconChevronDown />}
                        disabled={isPreview}
                      />
                    </>
                  ) : (
                    <Select
                      label="Strength & Form"
                      id="strength-and-form"
                      className={classes.inputStyle}
                      data={rxStrengthOptions}
                      placeholder="Select Strength & Form"
                      {...form.getInputProps("strengthAndForm")}
                      rightSection={<IconChevronDown />}
                      disabled={isPreview}
                      clearable
                    />
                  )}

                  <Select
                    label="Frequency"
                    id="frequency"
                    className={classes.inputStyle}
                    data={[...new Set(frequencyData)]}
                    placeholder="Select Frequency"
                    {...form.getInputProps("frequency")}
                    rightSection={<IconChevronDown />}
                    disabled={isPreview}
                  />
                </div>
              </div>
              {/* medication route */}
              <div className={classes.formRow}>
                <CustomSelectBox
                  id="medication-route"
                  label={"Medication Route"}
                  placeholder={"Select medication route"}
                  data={[
                    { value: "Buccal", label: "Buccal" },
                    { value: "Orally", label: "Orally" },
                    { value: "Intramuscular", label: "Intramuscular" },
                    { value: "Subcutaneous", label: "Subcutaneous" },
                    { value: "Cutaneous", label: "Cutaneous" },
                    { value: "Irrigation", label: "Irrigation" },
                    { value: "Laryngeal", label: "Laryngeal" },
                    { value: "Nasal", label: "Nasal" },
                    { value: "Not Applicable", label: "Not Applicable" },
                    { value: "Parenteral", label: "Parenteral" },
                    { value: "Rectal", label: "Rectal" },
                    { value: "Vaginal", label: "Vaginal" },
                    { value: "Sublingual", label: "Sublingual" },
                    { value: "Suppository", label: "Suppository" },
                    { value: "Injection", label: "Injection" },
                    { value: "Inhalation", label: "Inhalation" },
                    { value: "Topical", label: "Topical" },
                    { value: "Other", label: "Other" },
                  ]}
                  {...form.getInputProps("ingestionMode")}
                  withAsterisk
                  disabled={isPreview}
                />
                <CustomSelectBox
                  id="dose-form"
                  label={"Dose Form"}
                  placeholder={"Select dose form"}
                  data={[
                    "Tablet",
                    "Capsule",
                    "Syrup",
                    "Pill",
                    "Liquid",
                    "Cream",
                    "Oil",
                    "Ointment",
                    "Lotion",
                    "Gel",
                    "Gas",
                    "Solution",
                    "Inhalant",
                    "Injection",
                    "Insert",
                    "Suppository",
                    "Jelly",
                    "Lozenge",
                    "Paste",
                    "Patch",
                    "Rinse",
                    "Shampoo",
                    "Drops",
                    "Spray",
                    "Powder",
                  ]}
                  {...form.getInputProps("dosageForm")}
                  disabled={isPreview}
                />
              </div>

              <Box mb={10}>
                <Radio.Group
                  label="Use Medication Count?"
                  onChange={handleRadioChange}
                  value={isMedicationCountEnabled}
                  disabled={isPreview}
                  className={classes.radioGroupWrapper}
                >
                  <Group className={classes.radioGroup}>
                    <Radio disabled={isPreview} value="yes" label="Yes" />
                    <Radio disabled={isPreview} value="no" label="No" />
                  </Group>
                </Radio.Group>
              </Box>

              {/* medicineProvided */}
              <div className={classes.formRow}>
                {/* medication quantity */}
                <CountField
                  id="medication-quantity"
                  label="Medication Total Quantity"
                  withAsterisk={
                    isMedicationCountEnabled?.toLowerCase() !== "no"
                  }
                  value={form.values.totalMedicine}
                  error={form.errors.totalMedicine}
                  disabled={
                    isPreview ||
                    isMedicationCountEnabled?.toLowerCase() === "no"
                      ? true
                      : false
                  }
                  onChange={(e) => {
                    let value = e.target.value;
                    if (value.includes(".")) {
                      const [integerPart, decimalPart] = value.split(".");
                      if (decimalPart?.length > 1) {
                        value = `${integerPart}.${decimalPart?.slice(0, 1)}`;
                      }
                    }
                    form.setFieldValue("totalMedicine", value);
                  }}
                  onDecrement={() => {
                    const v = parseFloat(form.values.totalMedicine) || 0;
                    form.setFieldValue(
                      "totalMedicine",
                      String(Math.max(0, v - 1)),
                    );
                  }}
                  onIncrement={() => {
                    const v = parseFloat(form.values.totalMedicine) || 0;
                    form.setFieldValue("totalMedicine", String(v + 1));
                  }}
                />
                {/* medication count */}
                <CountField
                  id="current-medication-count"
                  labelNode={
                    <Tooltip
                      label="Update Current Count from Refill Medication"
                      placement="top"
                      offset={15}
                      withArrow
                      arrowSize={8}
                      disabled={
                        isPreview ||
                        !data ||
                        (data?.medicineRemaining === "unlimited" &&
                          data?.totalMedicine === "unlimited")
                      }
                    >
                      <span>Current Medication Count</span>
                    </Tooltip>
                  }
                  value={form.values.medicineRemaining}
                  error={form.errors.medicineRemaining}
                  disabled={
                    isPreview ||
                    isMedicationCountEnabled?.toLowerCase() === "no" ||
                    (isMedicationCountEnabled?.toLowerCase() === "yes" &&
                    data?.medicineRemaining === undefined
                      ? data?.medicineRemaining == "unlimited"
                      : data?.medicineRemaining !== "unlimited")
                      ? true
                      : false
                  }
                  onChange={(e) => {
                    let value = e.target.value;
                    if (value.includes(".")) {
                      const [integerPart, decimalPart] = value.split(".");
                      if (decimalPart?.length > 1) {
                        value = `${integerPart}.${decimalPart?.slice(0, 1)}`;
                      }
                    }
                    form.setFieldValue("medicineRemaining", value);
                  }}
                  onDecrement={() => {
                    const v = parseFloat(form.values.medicineRemaining) || 0;
                    form.setFieldValue(
                      "medicineRemaining",
                      String(Math.max(0, v - 1)),
                    );
                  }}
                  onIncrement={() => {
                    const v = parseFloat(form.values.medicineRemaining) || 0;
                    form.setFieldValue("medicineRemaining", String(v + 1));
                  }}
                />
                {/* administration count */}
                <CountField
                  id="administration-count"
                  label="Administration Count"
                  value={form.values.medicationadministered}
                  error={form.errors.medicationadministered}
                  disabled={isPreview}
                  onChange={(e) => {
                    let value = e.target.value;
                    if (value.includes(".")) {
                      const [integerPart, decimalPart] = value.split(".");
                      if (decimalPart?.length > 2) {
                        value = `${integerPart}.${decimalPart?.slice(0, 2)}`;
                      }
                    }
                    form.setFieldValue("medicationadministered", value);
                  }}
                  onDecrement={() => {
                    const v =
                      parseFloat(form.values.medicationadministered) || 0;
                    form.setFieldValue(
                      "medicationadministered",
                      String(Math.max(0, v - 1)),
                    );
                  }}
                  onIncrement={() => {
                    const v =
                      parseFloat(form.values.medicationadministered) || 0;
                    form.setFieldValue("medicationadministered", String(v + 1));
                  }}
                />
              </div>
              {/* use of medication */}
              <div className={classes.formRow}>
                <CustomTextArea
                  id="use-of-medication"
                  size="sm"
                  label={"Use of Medication"}
                  placeholder={"Enter medication use"}
                  minRows={3}
                  {...form.getInputProps("medicationUse")}
                  disabled={isPreview}
                />
              </div>
              {/* medication instruction */}
              <div className={classes.formRow}>
                <CustomTextArea
                  id="medication-instruction"
                  size="sm"
                  label={"Medication Instruction"}
                  placeholder={"Enter medication Instruction"}
                  minRows={3}
                  {...form.getInputProps("medicationInstruction")}
                  disabled={isPreview}
                />
              </div>

              <div className={classes.formRow}>
                {/* responsible for purchasing */}
                <CustomSelectBox
                  id="responsible-for-purchasing"
                  label={"Responsible for purchasing"}
                  placeholder={"Select purchasing party"}
                  data={[
                    { value: "Family", label: "Family" },
                    { value: "Care Facility", label: "Care Facility" },
                    { value: "Doctor/Nurse", label: "Doctor/Nurse" },
                    { value: "Other", label: "Other" },
                  ]}
                  {...form.getInputProps("responsibleParty")}
                  disabled={isPreview}
                />
                <CustomSelectBox
                  id="responsible-for-administering"
                  label={"Responsible for administering"}
                  placeholder={"Select administering party"}
                  data={[
                    { value: "Family", label: "Family" },
                    { value: "Care Facility", label: "Care Facility" },
                    { value: "Doctor/Nurse", label: "Doctor/Nurse" },
                    { value: "Other", label: "Other" },
                  ]}
                  {...form.getInputProps("administering")}
                  disabled={isPreview}
                />
              </div>

              <div className={classes.formRow}>
                {type === "PRN" && (
                  <DateInput
                    id="medication-start-date"
                    placeholder={"Pick a date"}
                    label="Medication Start Date"
                    {...form.getInputProps("medicationDate")}
                    onChange={onChangeMedStartDate}
                    withAsterisk
                    disabled={isPreview}
                    className={classes.inputStyle}
                    icon={<FiCalendar />}
                  />
                )}
                <DateInput
                  id="expriration-date"
                  minDate={new Date()}
                  placeholder={"Pick a date"}
                  label="Expiration Date"
                  disabled={isPreview}
                  {...form.getInputProps("expirationDate")}
                  onChange={onChangeMedEndDate}
                  clearable
                  className={classes.inputStyle}
                  icon={<FiCalendar />}
                />
              </div>
                {type !== "PRN" && (
                  <div>
                    {/* <p
                      style={{
                        fontSize: "14px",
                        fontWeight: 600,
                        color: "#000",
                        margin: "0 0 8px 0",
                      }}
                    >
                      Administration Schedule
                      <span style={{ color: "#000" }}>*</span>
                    </p> */}
                    <ScheduleMenu
                      form={form}
                      isPreview={isPreview}
                      data={data}
                    />
                  </div>
                )}

              {/* refills left */}
              <div className={classes.formRow}>
                <CountField
                  id="refills-left"
                  label="Refills Count"
                  value={form.values.refillsLeft}
                  error={form.errors.refillsLeft}
                  disabled={isPreview}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9]/g, "");
                    form.setFieldValue("refillsLeft", value);
                  }}
                  onDecrement={() => {
                    const v = parseInt(form.values.refillsLeft, 10);
                    if (!isNaN(v) && v > 0)
                      form.setFieldValue("refillsLeft", String(v - 1));
                  }}
                  onIncrement={() => {
                    const v = parseInt(form.values.refillsLeft, 10) || 0;
                    form.setFieldValue("refillsLeft", String(v + 1));
                  }}
                />
              </div>

              <div className={classes.uploadAndDateBox}>
                <div>
                  <p
                    style={{
                      fontSize: "14px",
                      fontWeight: 500,
                      marginBottom: "8px",
                      margin: "17px 0 0px 0",
                    }}
                  >
                    Doctors note
                  </p>
                  <div className={classes.dropzone}>
                    {!isPreview && (
                      <Dropzone
                        onDrop={async (newFiles) => {
                          if (!newFiles?.[0]) return;
                          const file = newFiles[0];
                          try {
                            const result = await uploadFileToS3Api({ file });
                            const sizeKB = file.size / 1024;
                            const sizeLabel =
                              sizeKB >= 1024
                                ? (sizeKB / 1024).toFixed(1) + " MB"
                                : sizeKB.toFixed(0) + " KB";
                            setFiles([
                              { ...result, name: file.name, sizeLabel },
                            ]);
                          } catch (error) {
                            showError?.(error?.message || "Upload failed");
                          }
                        }}
                        multiple={false}
                        onReject={(files) =>
                          console.log("rejected files", files)
                        }
                        disabled={isPreview}
                      >
                        <Group
                          position="center"
                          spacing="xl"
                          style={{ minHeight: rem(140), pointerEvents: "none" }}
                        >
                          <Dropzone.Accept></Dropzone.Accept>
                          <Dropzone.Reject></Dropzone.Reject>
                          <Dropzone.Idle></Dropzone.Idle>

                          <div className={classes.column}>
                            <EmptyUploadFile />
                            <p className={classes.uploadText}>
                              <span>Click to Upload</span> or Drag and Drop
                            </p>
                            <p className={classes.uploadSubText}>
                              Maximum File Size 2MB
                            </p>
                          </div>
                        </Group>
                      </Dropzone>
                    )}
                    {files?.length > 0 && (
                      <div className={classes.fileNameBox}>
                        <div className={classes.fileNameLeft}>
                          <IconFile
                            size={28}
                            color="#888"
                            strokeWidth={1.5}
                            style={{ flexShrink: 0 }}
                          />
                          <div className={classes.fileNameInfo}>
                            <p className={classes.fileNameText}>
                              {files[0]?.name || formatString(files[0]?.path)}
                            </p>
                            {files[0]?.sizeLabel && (
                              <p className={classes.fileSizeText}>
                                Size: {files[0]?.sizeLabel}
                              </p>
                            )}
                          </div>
                        </div>
                        <div className={classes.fileNameActions}>
                          <button
                            type="button"
                            className={classes.fileViewBtn}
                            onClick={() =>
                              window.open(files[0]?.uploadURL, "_blank")
                            }
                          >
                            <EyeIconSvg
                              size={22}
                              color="#555"
                              strokeWidth={1.5}
                            />
                          </button>
                          <IoIosCloseCircle
                            color="#888"
                            size={22}
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              setFiles([]);
                              form.setFieldValue("files", []);
                            }}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className={classes.datePicker}>
                  <DatePickerInput
                    id="order-date"
                    label="Order Date"
                    placeholder="Pick a date"
                    className={classes.inputStyle}
                    icon={<FiCalendar />}
                    {...form.getInputProps("orderDate")}
                    disabled={isPreview}
                  />
                </div>
                {!isPreview && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "12px",
                      marginTop: "24px",
                      width: "100%",
                    }}
                  >
                    <Button
                      id="cancel-medication"
                      type="button"
                      variant="subtle"
                      className={classes.cancelButton}
                      onClick={() => {
                        onclose();
                        form?.reset();
                        setRxStrengthOptions([]);
                      }}
                    >
                      Cancel
                    </Button>
                    <Button
                      id="save-medication"
                      loading={loading}
                      type="submit"
                      className={classes.submitButton}
                    >
                      Save
                    </Button>
                  </div>
                )}
              </div>
              {/* {data?.doctorNote && isPreview && (
                <>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <b>Download</b>
                    <img
                      src="/assets/images/downloadFolder.png"
                      alt="download"
                      width={30}
                      style={{ cursor: "pointer" }}
                      onClick={() => handleDownloadFile(data?.doctorNote)}
                    />
                  </div>
                  <div style={{ marginTop: "20px" }}>
                    <span style={{ color: "transparent" }}>.</span>
                  </div>
                </>
              )} */}
            </Box>
          </div>
        </div>
      </form>
      <ConfirmationModal
        opened={confirmModal}
        close={confirmClose}
        handleEdit={() => {
          handleEdit(true);
        }}
        // handleNewVersion={() => {
        //   handleNewVersion();
        // }}
      />
      <VersionUpdateModal
        opened={versionUpdateModal}
        close={versionUpdateClose}
        loading={loading}
        existingExpirationDate={form.values?.expirationDate}
        handleEdit={() => {
          handleUpdateThisMedication();
        }}
        handleNewVersion={(startDate, expirationDate) => {
          handleNewVersion(startDate, expirationDate);
        }}
      />
    </Drawer>
  );
};

const CustomTextInput = ({ ...rest }) => {
  const { classes } = useStyles();

  return <TextInput className={classes.inputStyle} {...rest} />;
};

const CustomSelectBox = ({ ...rest }) => {
  const { classes } = useStyles();

  return (
    <Select
      {...rest}
      rightSection={<IconChevronDown />}
      className={classes.inputStyle}
    />
  );
};

const CustomTextArea = ({ label, withAsterisk, ...rest }) => {
  const { classes } = useStyles();
  return (
    <div style={{ width: "100%" }}>
      <Textarea
        label={label}
        withAsterisk={withAsterisk}
        className={classes.inputStyle}
        {...rest}
      />
    </div>
  );
};

const stepBtnStyle = {
  width: "28px",
  height: "28px",
  borderRadius: "50%",
  border: "1.5px solid #bbb",
  backgroundColor: "transparent",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "18px",
  lineHeight: 1,
  flexShrink: 0,
  padding: 0,
  color: "#333",
};

const CountField = ({
  value,
  onChange,
  onDecrement,
  onIncrement,
  disabled,
  label,
  labelNode,
  error,
  withAsterisk,
}) => {
  const { classes } = useStyles();
  return (
  <div style={{ width: "100%", minWidth: 0 }}>
    <div
      style={{
        fontSize: "14px",
        fontWeight: 500,
        marginBottom: "6px",
        color: disabled ? "#aaa" : "inherit",
      }}
    >
      {labelNode || label}
      {withAsterisk && (
        <span style={{ color: "#000", marginLeft: "2px" }}>*</span>
      )}
    </div>
    <div
      style={{
        display: "flex",
        alignItems: "center",
        backgroundColor: "#fff",
        borderRadius: "8px",
        padding: "8px 12px",
        gap: "8px",
        border: "1px solid #E5E5E5",
        width: "100%",
        boxSizing: "border-box",
      }}
    >
      <button
        type="button"
        onClick={onDecrement}
        disabled={disabled}
        style={{
          ...stepBtnStyle,
          opacity: disabled ? 0.4 : 1,
          cursor: disabled ? "not-allowed" : "pointer",
        }}
      >
        −
      </button>
      <input
        value={value ?? ""}
        onChange={onChange}
        disabled={disabled}
        type="number"
        className={classes.noSpinner}
        placeholder={"0"}
        style={{
          flex: 1,
          border: "none",
          backgroundColor: "transparent",
          textAlign: "center",
          outline: "none",
          fontSize: "14px",
          color: disabled ? "#aaa" : "#000",
          minWidth: 0,
          borderRadius: "4px",
        }}
      />
      <button
        type="button"
        onClick={onIncrement}
        disabled={disabled}
        style={{
          ...stepBtnStyle,
          width: "30px",
          height: "30px",
          opacity: disabled ? 0.4 : 1,
          cursor: disabled ? "not-allowed" : "pointer",
        }}
      >
        +
      </button>
    </div>
    {error && (
      <div style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
        {error}
      </div>
    )}
  </div>
  );
};

export default AddNewMedicationModal;
